// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3d9abfaa","290":"bb8afe9b","356":"7be0d0c7","400":"47016a5e","930":"d5d1c680"}[chunkId] + ".chunk.js";
};